import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { ServiceCode } from '@/types';

interface ServicesContextType {
  activeServices: ServiceCode[];
  isServiceActive: (code: ServiceCode) => boolean;
  refreshServices: () => Promise<void>;
}

const ServicesContext = createContext<ServicesContextType | undefined>(undefined);

export const ServicesProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [activeServices, setActiveServices] = useState<ServiceCode[]>([]);

  const refreshServices = async () => {
    // Mock fetching services for now. 
    // In a real scenario, this would fetch from the API based on the current product/user context.
    // For now, we'll simulate some active services.
    await new Promise(resolve => setTimeout(resolve, 500)); // Simulate latency
    setActiveServices(['RELATORIOS', 'COORDENACAO', 'GESTAO']);
  };

  const isServiceActive = (code: ServiceCode) => {
    return activeServices.includes(code);
  };

  useEffect(() => {
    refreshServices();
  }, []);

  return (
    <ServicesContext.Provider value={{ activeServices, isServiceActive, refreshServices }}>
      {children}
    </ServicesContext.Provider>
  );
};

export const useServices = () => {
  const context = useContext(ServicesContext);
  if (context === undefined) {
    throw new Error('useServices must be used within a ServicesProvider');
  }
  return context;
};
